import styled from "styled-components"
import { KeyboardDatePicker } from "@material-ui/pickers"

export const StyledKeyboardDatePicker = styled(KeyboardDatePicker)``
